<div class="header-title">
	<div class="flex u-align-items-center u-pa-20">
		<div class="flex flex-align-center">
			<a routerLink="/button" aria-label="back"
				class="u-button u-button--link u-button--back u-button-icon-left u-ma-0 u-button--auto" type="button">
				<span class="u-icon icon-chevron-left"></span>
				<span class="u-button-text">Back</span>
			</a>
		</div>
		<div class="page-title flex u-w-100 u-justify-content-center u-position-absolute u-position-left">
			<h1 class="font-semibold u-ma-0 flex header-title--name">Draggable</h1>
		</div>
	</div>
	<div class="c-header__gradient"></div>
</div>
<div class="content content--modifier-height">
	<h2>Draggable Element</h2>
	<p>Click and hold the mouse button down while moving the element</p>
	<p> draggable with close icon</p>
	  <maced-draggable id ="drag1" [hasCloseButtonInside] = "true" buttonId = "Close" ariaLabel = "draggable" closeButtonAriaLabel = "draggable close" [toolTipData]="toolTipData">
		content goes here
	  </maced-draggable>
	  <br>
  </div>